/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the MIT License. See the accompanying LICENSE file for terms.
 */

import React from 'react';
import PropTypes from 'prop-types';
import DragLayer from 'react-dnd/lib/DragLayer';

const layerStyles: React.CSSProperties = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 100,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
};

function collect(monitor) {
    const item = monitor.getItem();
    let name;
    if (item !== null) {
        name = item.itemForm !== undefined ? item.itemForm : item.rule;
    }
    return {
        id: item && item.id,
        name: item && name,
        currentOffset: monitor.getSourceClientOffset(),
        initialOffset: monitor.getInitialSourceClientOffset(),
        isDragging: monitor.isDragging()
    };
}

function getItemStyles(props) {
    const {initialOffset, currentOffset} = props;
    if (!initialOffset || !currentOffset) {
        return {
            display: 'none',
        }
    }

    let {x, y} = currentOffset;

    const transform = `translate(${x}px, ${y}px)`;

    return {
        pointerEvents: 'none',
        transform: transform,
        WebkitTransform: transform
    };
}

function ItemPreview(props) {
    if (!props.isDragging) {
        return <span/>;
    }

    return (
        <div style={layerStyles}>
            <div
                className="item preview"
                style={getItemStyles(props)}>
                {props.name}
            </div>
        </div>
    );
}

ItemPreview.propTypes = {
    id: PropTypes.number,
    name: PropTypes.string,
    currentOffset: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number
    }),
    isDragging: PropTypes.bool
};

export default DragLayer(collect)(ItemPreview);
